import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { logUsage } from "owa-analytics";
import getDensityOptionState from "../store/store";
import { saveDensityOption } from "./saveDensityOption";

export default async function saveDensityOptionQuickSettings(): Promise<void> {
    const densityOptionSelected = getDensityOptionState().densityModeSelected;
    
    if (densityOptionSelected !== null) {
        logUsage("DisplayDensityQuickSettings", getGlobalSettingsAccountMailboxInfo(), [
            densityOptionSelected,
        ]);
        return saveDensityOption(densityOptionSelected);
    }
}
